import { render, staticRenderFns } from "./interface-debugger.vue?vue&type=template&id=3670d8eb&scoped=true&"
import script from "./interface-debugger.vue?vue&type=script&lang=js&"
export * from "./interface-debugger.vue?vue&type=script&lang=js&"
import style0 from "./interface-debugger.vue?vue&type=style&index=0&id=3670d8eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670d8eb",
  null
  
)

export default component.exports